import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    powerFlowDirection: Port.powerFlowDirection.literals.output,
}).default({});

const WindBase = z.object({
    type: z.literal('wind').default('wind'),
    electrical: z
        .object({
            ports: z.tuple([port]).default([undefined]),
        })
        .default({}),
});

export const WindValidator = ComponentValidator.merge(WindBase);
export const WindPayloadValidator = ComponentPayloadValidator.merge(WindBase);

export const WindDefinition: ComponentDefinition = {
    type: 'wind',
    name: 'Wind',
    plural: 'Wind',
    indicator: 'WIND',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: true,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['output'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: WindValidator,
        payload: WindPayloadValidator,
    },
};

export type Wind = z.infer<typeof WindValidator>;
export type WindPayload = z.infer<typeof WindPayloadValidator>;
